import Hero from "../components/home/Hero";
import CollectionPreview from "../components/home/CollectionPreview";
import Featured from "../components/home/Featured";

const Home = () => {
  return (
    <>
      <Hero />
      <CollectionPreview />
      <Featured />
    </>
  );
};

export default Home;